export default __webpack_public_path__ + "static/media/regImg.f5806f48.png";